export default __webpack_public_path__ + "static/media/bottle_formosa.ac85fb79.png";